<!--
 * @Descripttion: 
 * @version: 
 * @Author: dengyao
 * @Date: 2023-12-19 20:25:01
 * @LastEditors: dengyao
 * @LastEditTime: 2024-07-24 10:30:45
-->
<template>
  <ConfigProvider :locale="localeMap[locale].ant" :autoInsertSpaceInButton="false">
    <div class="content-wrap" v-wechat-title="$lang($route.meta.title)">
      <router-view />
    </div>
  </ConfigProvider>
</template>
<script lang="ts" setup>
import { computed, onMounted, reactive, watch } from 'vue'
import { ConfigProvider } from 'ant-design-vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import ph from '@/plugins/phi/phi'
import enUS from 'ant-design-vue/lib/locale-provider/id_ID'
import { Locale } from 'ant-design-vue/lib/locale-provider'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn.js'
import 'dayjs/locale/tl-ph.js'
import 'dayjs/locale/en.js'
import { useSettingStore, useAuthStore } from '@/store'
import LangType from '@/utils/enums/LangType'
import { useRouter } from 'vue-router'
import useMatomo from '@/hooks/useMatomo'

const router = useRouter()
const authStore = useAuthStore()
const matomo = useMatomo()
type Lang = keyof typeof LangType
const sysSetting = useSettingStore()

const localeMap = reactive<Record<Lang, { ant: Locale; dayjs: string }>>({
  zh: {
    ant: zhCN,
    dayjs: 'zh-ch'
  },
  ph: {
    ant: ph,
    dayjs: 'tl-ph'
  },
  en: {
    ant: enUS,
    dayjs: 'en'
  }
})
const locale = computed(() => sysSetting.locale)

dayjs.locale(localeMap[locale.value].dayjs)

watch(
  () => locale.value,
  (c) => {
    dayjs.locale(localeMap[c].dayjs)
  }
)
watch(
  () => router.currentRoute.value,
  (newValue: any) => {
    // 这里延迟是因为matomo sdk加载是异步非阻塞加载，所以为了能正确的获取到window上matomo的实例，我们这里会有略微延迟
    setTimeout(() => {
      /**
       * 记录跳转页面及页面标题  userAccount及id均为业务系统数据，此处做拼接传入
       **/
      const name =
        authStore.userInfo?.stationCode !== undefined
          ? `${authStore.userInfo?.stationCode} | ${authStore.userInfo?.stationName}`
          : ''
      matomo.setUserId(name)
      matomo.setCustomUrl(window.location.href)
      matomo.trackPageView(router.currentRoute.value.meta.title)
    }, 500)
  }
)
onMounted(() => {
  let loading = document.getElementById('preloader')
  if (loading !== null) {
    document.body.removeChild(loading)
  }
})
</script>
<style>
#app {
  min-width: 1200px;
  width: 100%;
  font-family: PingFangSC, PingFangSC-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.content-wrap {
  height: 100%;
}

.ant-table-cell:empty:after {
  content: '--';
}
</style>
